import { phoneNumberFormater } from "@/common/utils";

export default {
	install(Vue) {
		Vue.filter("phoneNumber", function (phone) {
			return phoneNumberFormater(phone);
		});
	}
};
